import gql from 'graphql-tag'

const query = gql`
query listIngredients($type: ingredientTypes!) {
	cashAssist {
		listIngredients(type: $type) {
			id
			uuid
			group
			code
			name
			units
		}
	}
}`

export default query
